import { render, staticRenderFns } from "./finess.vue?vue&type=template&id=71b74d2c&scoped=true"
import script from "./finess.vue?vue&type=script&lang=js"
export * from "./finess.vue?vue&type=script&lang=js"
import style0 from "./finess.vue?vue&type=style&index=0&id=71b74d2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b74d2c",
  null
  
)

export default component.exports